module.exports = __webpack_public_path__ + "static/img/acq-2.e0211d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acq-2.png
// module id = 6QLT
// module chunks = 1